<template>
    <div class="request_form">
      <CCard>
        <CCardBody>
            
            <div class="row" style="margin-top:15px;">
                <div class="col-lg-12">
                    <div class="panel">
                        <div class="panel-heading">
                            <h3 class="panel-title">
                                <span class="ng-scope"><i class="fa fa-fw ti-pencil"></i> Order Entry Request</span>
                            </h3>
                            <!-- <img src="../assets/ASI LOGO.png" alt="Paramount Apparel" /> -->
                        </div>
                        <div class="panel-body">
                            <div>
                                <form v-on:submit.prevent="submitForm()" enctype="multipart/form-data" ref="asi_input" name="containerform" id="formContainer" autocomplete="on" class="form-horizontal" role="form">
                                    <!-- <input type="hidden" name="userId" :value="this.$store.state.user.id" />
                                    <input type="hidden" name="userName" :value="this.$store.state.user.name" />
                                    <input type="hidden" name="userPicture" :value="this.$store.state.user.picture" /> -->
                                    <fieldset>
                                        <legend>Info</legend>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">Customer Name
                                            </label>
                                            <div class="col-sm-8">
                                                <input v-model="form.customer_name" name="customer_name" type="text" id="customer_name" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">Account #
                                            </label>
                                            <div class="col-sm-8">
                                                <input v-model="form.account_number" name="account_number" type="text" id="account_number" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">CC#
                                            </label>
                                            <div class="col-sm-8">
                                                <input v-model="form.cc_number" name="cc_number" type="text" id="cc_number" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">Log#
                                            </label>
                                            <div class="col-sm-8">
                                                <input v-model="form.log_number" name="log_number" type="text" id="log_number" class="form-control" />
                                            </div>
                                        </div>
                                        <div class="form-group" v-show="typeOfRequest === 'new'">
                                            <label class="control-label col-sm-4" for="csr_name">CSR
                                            </label>
                                            <div class="col-sm-8">
                                                <v-select v-if="csr_options !== null" style="height:34px;padding:0;width:100%;" placeholder="Select CSR" v-model="form.csr_name" :options="csr_options" required="true"></v-select>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="prebook">Prebook?
                                            </label>
                                            <div class="col-sm-8 checkarea2 container">
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.prebook" type="radio" value="1" required /><span>Yes</span></label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.prebook" type="radio" value="0" /><span>No</span></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">For Today's Ship Date
                                            </label>
                                            <div class="col-sm-8 checkarea2 container">
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.top_priority" type="radio" value="1" /><span>Yes</span></label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.top_priority" type="radio" value="0" /><span>No</span></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">30+ Day Ship Date
                                            </label>
                                            <div class="col-sm-8 checkarea2 container">
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.thirty_day_ship" type="radio" value="1" /><span>Yes</span></label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.thirty_day_ship" type="radio" value="0" /><span>No</span></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">Auto Release
                                            </label>
                                            <div class="col-sm-8 checkarea2 container">
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.auto_release" type="radio" value="1" /><span>Yes</span></label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.auto_release" type="radio" value="0" /><span>No</span></label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">Tonal?
                                            </label>
                                            <div class="col-sm-8 checkarea2 container">
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.tonal" type="radio" value="1" /><span>Yes</span></label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.tonal" type="radio" value="0" /><span>No</span></label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">Blank?
                                            </label>
                                            <div class="col-sm-8 checkarea2 container">
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.blank" type="radio" value="1" /><span>Yes</span></label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.blank" type="radio" value="0" /><span>No</span></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">Visor/Bucket?
                                            </label>
                                            <div class="col-sm-8 checkarea2 container">
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.visor_bucket" type="radio" value="1" /><span>Yes</span></label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.visor_bucket" type="radio" value="0" /><span>No</span></label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="csr_name">Event?
                                            </label>
                                            <div class="col-sm-8 checkarea2 container">
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.event" type="radio" value="1" /><span>Yes</span></label>
                                                </div>
                                                <div class="col-sm-4">
                                                    <label>
                                                        <input v-model="form.event" type="radio" value="0" /><span>No</span></label>
                                                </div>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <!-- <fieldset v-if="form.form_type === 'order_entry'">
                                        <legend>Component Type</legend>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="component_description">Description
                                            </label>
                                            <div class="col-sm-8">
                                                <v-select style="text-transform: capitalize;" name="component_description" placeholder="Select Component Type" v-model="form.component_description" required :options="typeOptions"></v-select>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class="control-label col-sm-4" for="component_type">Type
                                            </label>
                                            <div class="col-sm-8">
                                                <input type="text" class="form-control" disabled name="component_type" v-model="component_type" required ></input>
                                            </div>
                                        </div>
                                    </fieldset> -->
                                    <fieldset v-if="!form.blank">
                                        <legend>Tapes</legend>
                                        <div id="product1" v-for="tape in form.tapes" class="clonedInput1">
                                            <div class="col-sm-12">
                                                <div class="form-group">
                                                    <label class="control-label col-sm-4">Tape #</label>
                                                    <div class="col-sm-8">
                                                        <input type="text" class="form-control" v-model="tape.number">
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label class="control-label col-sm-4">Position</label>
                                                    <div class="col-sm-8">
                                                        <!-- <input type="text" class="form-control" v-model="product.position" id="style_color" name="style_color"> -->
                                                        <v-select multiple style="width:100%;" required placeholder="Select Position" v-model="tape.position" :options="positionOptions"></v-select>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label class="control-label col-sm-4">Name</label>
                                                    <div class="col-sm-8">
                                                        <input type="text" class="form-control" v-model="tape.name">
                                                    </div>
                                                </div>
                                                <div v-if="tape.position && tape.position.indexOf('Other') > -1" class="form-group">
                                                    <label class="control-label col-sm-4">Other</label>
                                                    <div class="col-sm-8">
                                                        <input type="text" class="form-control" v-model="tape.extra" />
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <label class="control-label col-sm-4">Technique</label>
                                                    <div class="col-sm-8">
                                                        <v-select v-model="tape.technique" :options="technique_options"></v-select>
                                                    </div>
                                                </div>
                                            </div>
                                            <spacer />
                                        </div>
                                        <div class="adddel" style="margin-top:15px;">
                                            <CButton size="sm" color="success" @click="form.tapes.push({number: '', name: '', position: '', extra: '', stitch_count: '', technique: ''})">Add Tape</CButton>
                                            <CButton size="sm" class="ml-2" color="danger" @click="form.tapes.pop()"><span class="btnText">REMOVE TAPE</span></CButton>
                                        </div>
                                    </fieldset>
                                    <fieldset>
                                        <legend>Comments</legend>
                                        <div class="col-12 full autoheight">
                                            <textarea style="width:100%;" v-model="form.comments" rows="7"></textarea>
                                        </div>
                                    </fieldset>

                                    <fieldset>
                                        <legend>Attach Reference Art</legend>
                                            <div style="width: 100%;float:left;" class="form-group full autoheight">
                                                <reference-art @image-selected="imageSelected"></reference-art>
                                            </div>
                                    </fieldset>
                                    <!-- <fieldset id="uploadWrapper">
                                        <legend>Upload</legend>
                                        <div class="form-group full autoheight">
                                            <h4 class="upload">Upload Image If Needed</h4>
                                            <input type="file" name="images[]" class="dropify" data-max-file-size="10M" data-allowed-file-extensions="pdf png jpg jpeg ai zip xls eps bmp emb dst" multiple />
                                        </div>
                                    </fieldset> -->
                                    <div class="form-actions">
                                        <div class="col-sm-12">
                                            <input type="submit" v-show="typeOfRequest === 'new' && !loading && configureShow()" class="btn btn-primary" tabindex="-1" value="Submit Request"></input>
                                            <input type="submit" v-show="typeOfRequest === 'save'" class="btn btn-primary" tabindex="-1" value="Save Request"></input>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import ReferenceArt from './reference_art'
var methods = {}

methods.submitForm = function () {
    this.loading = true
  const postData = {
    form: this.form,
    ref_images: this.refImages
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/flow/submitOrderEntry?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.loading = false
    this.$emit('submitted', this.form)
  }).catch(e => {
    window.Swal.fire({
        type: 'error',
        title: 'Oops!',
        text: 'Looks like something went wrong.'
    })
    this.loading = false
  })
}

methods.configureShow = function () {
    if (this.form.csr_name) {
        return true
    } else {
        return false
    }
}

methods.checkChecked = function(image) {
    if (this.imageArray.indexOf(image.id) > -1) {
        // if (this.form.image === image.id) {
            return true
        // }
    }
    return false
}

methods.imageClicked = function(image) {
    // if (image.id) {
    //     this.form.image = image.id
    // } else {
    //     this.form.image = image.file_name
    // }
    var index = this.imageArray.indexOf(image.id)
    if (index > -1) {
        this.imageArray.splice(index, 1)
    } else {
        this.imageArray.push(image.id)
    }
}



methods.getCsrs = function () {
    var that = this
    axios.post(this.$apiAdress + '/api/flow/getCsrs?token=' + localStorage.getItem('api_token')).then(response => {
        // if (response.status === 200) {
            this.csr_options = []
            response.data.forEach(function (user) {
                var obj = {
                    value: user.id,
                    label: user.name
                }
                that.csr_options.push(obj)
            })
        // }
    })
}

methods.imageSelected = function (images) {
    this.refImages = images
}

export default {
    name: "OrderEntryRequest",
    components: {
      ReferenceArt
    },
    data: function() {
        return {
            loading: false,
            form: {
                form_type: 'order_entry',
                type: 'order_entry',
                comments: '',
                component_description: '',
                csr_name: '',
                customer_name: '',
                account_number: '',
                top_priority: 0,
                cc_number: '',
                log_number: '',
                thirty_day_ship: 0,
                auto_release: 1,
                blank: 0,
                tonal: '',
                visor_bucket: '',
                event: 0,
                prebook: '',
                tapes: [{
                    number: '',
                    name: '',
                    position: '',
                    extra: '',
                    stitch_count: '',
                    technique: ''
                }]
            },
            refImages: null,
            typeOfRequest: 'new',
            csr_options: [],
            technique_options: ['Applique', 'Embroidery', 'Heat Seal', 'Pad Print & Embroidery', 'Printed Twill', 'DDD (sublimation on 3D)', 'Retro Patch'],
            positionOptions: ['Front', 'WRS Left Side', 'WRS Right Side', 'Back', 'Backstrap', 'Other'],
            typeOptions: ['retro patch', '3D insignia', 'sublimation marrow edge patch', 'woven label marrow edge'],
            showImages: true,
            imageArray: []
        }
    },
    props: ['newData', 'group'],
    computed: {
        component_type: function() {
            if (this.form.component_description !== '') {
                switch (this.form.component_description) {
                    case 'retro patch':
                        return 'PPE'
                        break
                    case '3D insignia':
                        return 'PPHI'
                        break
                    case 'sublimation marrow edge patch':
                        return 'PPSM'
                        break
                    case 'woven label marrow edge':
                        return 'PPWE'
                        break
                    default:
                        return null
                        break
                }
            } else {
                return ''
            }
        }
    },
    methods: methods,
    mounted: function() {
      var that = this
      console.log(that)
        if (this.newData) {
          var obj = {}
          var group = {}
          for (var key in this.newData) {
            obj[key] = this.newData[key]
          }
          for (var key in this.group) {
            group[key] = this.group[key]
          }
          console.log(obj)
          console.log(this.form)
          this.form.customer_name = obj.customer_name
          this.form.account_number = obj.customer_number
          this.form.cc_number = group.cc_number
          this.form.log_number = group.as400_log_number
        }
        this.getCsrs()
    },
    destroyed: function() {

    }
}
</script>
<style lang="scss" scoped>
  .form-group {
    width:50%;
    float:left;
    min-height:40px;

    .v-select {
      width:100%;
    }

    div {
      float:left;
    }
    label {
      float:left;
    }
  }
</style>